import { Box, styled } from "@mui/material";

export const StyledPdfViewer = styled(Box)(({ theme }) => ({
  background: theme.color.dark,
  overflow: "scroll",
  height: "90%",
  paddingBlock: "2rem",

  h2: {
    color: theme.color.background,
    textAlign: "center",
    paddingBottom: "1rem",
  },
  ".viewport": {
    touchAction: "pan-x pan-y",
    overscrollBehavior: "contain",
  },
  ".document": {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    background: theme.color.dark,
    ".page": {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      background: theme.color.dark,
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {},
}));
